var map = {
	"./ModernBooleanCheckChecked.svg": "./src/images-v1/ModernBooleanCheckChecked.svg",
	"./ModernBooleanCheckInd.svg": "./src/images-v1/ModernBooleanCheckInd.svg",
	"./ModernBooleanCheckUnchecked.svg": "./src/images-v1/ModernBooleanCheckUnchecked.svg",
	"./ModernCheck.svg": "./src/images-v1/ModernCheck.svg",
	"./ModernRadio.svg": "./src/images-v1/ModernRadio.svg",
	"./ProgressButton.svg": "./src/images-v1/ProgressButton.svg",
	"./RemoveFile.svg": "./src/images-v1/RemoveFile.svg",
	"./TimerCircle.svg": "./src/images-v1/TimerCircle.svg",
	"./add-24x24.svg": "./src/images-v1/add-24x24.svg",
	"./arrowleft-16x16.svg": "./src/images-v1/arrowleft-16x16.svg",
	"./arrowright-16x16.svg": "./src/images-v1/arrowright-16x16.svg",
	"./camera-24x24.svg": "./src/images-v1/camera-24x24.svg",
	"./camera-32x32.svg": "./src/images-v1/camera-32x32.svg",
	"./cancel-24x24.svg": "./src/images-v1/cancel-24x24.svg",
	"./check-16x16.svg": "./src/images-v1/check-16x16.svg",
	"./check-24x24.svg": "./src/images-v1/check-24x24.svg",
	"./chevrondown-24x24.svg": "./src/images-v1/chevrondown-24x24.svg",
	"./chevronright-16x16.svg": "./src/images-v1/chevronright-16x16.svg",
	"./clear-16x16.svg": "./src/images-v1/clear-16x16.svg",
	"./clear-24x24.svg": "./src/images-v1/clear-24x24.svg",
	"./close-16x16.svg": "./src/images-v1/close-16x16.svg",
	"./close-24x24.svg": "./src/images-v1/close-24x24.svg",
	"./collapse-16x16.svg": "./src/images-v1/collapse-16x16.svg",
	"./collapsedetails-16x16.svg": "./src/images-v1/collapsedetails-16x16.svg",
	"./delete-16x16.svg": "./src/images-v1/delete-16x16.svg",
	"./delete-24x24.svg": "./src/images-v1/delete-24x24.svg",
	"./drag-24x24.svg": "./src/images-v1/drag-24x24.svg",
	"./draghorizontal-24x16.svg": "./src/images-v1/draghorizontal-24x16.svg",
	"./editsmall-16x16.svg": "./src/images-v1/editsmall-16x16.svg",
	"./expand-16x16.svg": "./src/images-v1/expand-16x16.svg",
	"./expanddetails-16x16.svg": "./src/images-v1/expanddetails-16x16.svg",
	"./file-72x72.svg": "./src/images-v1/file-72x72.svg",
	"./flip-24x24.svg": "./src/images-v1/flip-24x24.svg",
	"./folder-24x24.svg": "./src/images-v1/folder-24x24.svg",
	"./fullsize-16x16.svg": "./src/images-v1/fullsize-16x16.svg",
	"./image-48x48.svg": "./src/images-v1/image-48x48.svg",
	"./loading-48x48.svg": "./src/images-v1/loading-48x48.svg",
	"./maximize-16x16.svg": "./src/images-v1/maximize-16x16.svg",
	"./minimize-16x16.svg": "./src/images-v1/minimize-16x16.svg",
	"./more-24x24.svg": "./src/images-v1/more-24x24.svg",
	"./navmenu-24x24.svg": "./src/images-v1/navmenu-24x24.svg",
	"./noimage-48x48.svg": "./src/images-v1/noimage-48x48.svg",
	"./ranking-arrows.svg": "./src/images-v1/ranking-arrows.svg",
	"./rankingundefined-16x16.svg": "./src/images-v1/rankingundefined-16x16.svg",
	"./rating-star-2.svg": "./src/images-v1/rating-star-2.svg",
	"./rating-star-small-2.svg": "./src/images-v1/rating-star-small-2.svg",
	"./rating-star-small.svg": "./src/images-v1/rating-star-small.svg",
	"./rating-star.svg": "./src/images-v1/rating-star.svg",
	"./reorder-24x24.svg": "./src/images-v1/reorder-24x24.svg",
	"./restoredown-16x16.svg": "./src/images-v1/restoredown-16x16.svg",
	"./search-24x24.svg": "./src/images-v1/search-24x24.svg",
	"./smiley-rate1-24x24.svg": "./src/images-v1/smiley-rate1-24x24.svg",
	"./smiley-rate10-24x24.svg": "./src/images-v1/smiley-rate10-24x24.svg",
	"./smiley-rate2-24x24.svg": "./src/images-v1/smiley-rate2-24x24.svg",
	"./smiley-rate3-24x24.svg": "./src/images-v1/smiley-rate3-24x24.svg",
	"./smiley-rate4-24x24.svg": "./src/images-v1/smiley-rate4-24x24.svg",
	"./smiley-rate5-24x24.svg": "./src/images-v1/smiley-rate5-24x24.svg",
	"./smiley-rate6-24x24.svg": "./src/images-v1/smiley-rate6-24x24.svg",
	"./smiley-rate7-24x24.svg": "./src/images-v1/smiley-rate7-24x24.svg",
	"./smiley-rate8-24x24.svg": "./src/images-v1/smiley-rate8-24x24.svg",
	"./smiley-rate9-24x24.svg": "./src/images-v1/smiley-rate9-24x24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images-v1 sync recursive \\.svg$";